import { render, staticRenderFns } from "./SearchGene.vue?vue&type=template&id=9df112b8&"
import script from "./SearchGene.vue?vue&type=script&lang=js&"
export * from "./SearchGene.vue?vue&type=script&lang=js&"
import style0 from "./SearchGene.vue?vue&type=style&index=0&id=9df112b8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports